import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { BRAND } from "@/constants/content";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("kinflex_admin_token", data.token);
      localStorage.setItem("kinflex_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back!");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-soft-aurora flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-medical-grid opacity-40 pointer-events-none" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <img src={BRAND.logo} alt="KINFLEX" className="h-12 w-12 rounded-lg object-cover ring-1 ring-slate-200" />
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-900">KINFLEX</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-teal-600 font-semibold">Home Healthcare</div>
          </div>
        </Link>

        <div className="rounded-3xl bg-white border border-slate-100 shadow-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-teal-500 to-blue-900 text-white flex items-center justify-center">
              <Lock className="h-5 w-5" />
            </div>
            <div>
              <h1 className="font-display font-bold text-slate-900 text-xl">Admin Login</h1>
              <p className="text-sm text-slate-500">Manage bookings & leads</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs font-semibold">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@kinflex.com" required className="mt-1.5" data-testid="admin-login-email" />
            </div>
            <div>
              <Label className="text-xs font-semibold">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required className="mt-1.5" data-testid="admin-login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-full bg-blue-900 hover:bg-blue-800 font-semibold" data-testid="admin-login-submit">
              {loading ? "Signing in..." : <>Sign In <ArrowRight className="h-4 w-4 ml-2" /></>}
            </Button>
          </form>
        </div>

        <Link to="/" className="mt-6 block text-center text-sm text-slate-500 hover:text-teal-700">
          ← Back to website
        </Link>
      </div>
    </div>
  );
}
